import { render, staticRenderFns } from "./DepartmentChoose.vue?vue&type=template&id=55ac082a&scoped=true"
import script from "./DepartmentChoose.vue?vue&type=script&lang=js"
export * from "./DepartmentChoose.vue?vue&type=script&lang=js"
import style0 from "./DepartmentChoose.vue?vue&type=style&index=0&id=55ac082a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ac082a",
  null
  
)

export default component.exports